
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface AnalyticsTabsProps {
  defaultValue: string;
  children: ReactNode;
  className?: string;
}

interface AnalyticsTabTriggerProps {
  value: string;
  icon: ReactNode;
  label: string;
  count?: number;
}

export const AnalyticsTabs = ({ defaultValue, children, className }: AnalyticsTabsProps) => {
  return (
    <Tabs defaultValue={defaultValue} className={cn("w-full", className)}>
      {children}
    </Tabs>
  );
};

export const AnalyticsTabsList = ({ children }: { children: ReactNode }) => {
  return (
    <TabsList className="grid w-full grid-cols-3 h-12 bg-muted backdrop-blur-sm border border-border">
      {children}
    </TabsList>
  );
};

export const AnalyticsTabTrigger = ({ value, icon, label, count }: AnalyticsTabTriggerProps) => {
  return (
    <TabsTrigger 
      value={value} 
      className="flex items-center gap-2 data-[state=active]:bg-background data-[state=active]:shadow-sm transition-all duration-200"
    >
      <div className="text-current">{icon}</div>
      <span className="font-medium">{label}</span>
      {count !== undefined && (
        <span className="ml-1 px-2 py-0.5 text-xs bg-primary/10 text-primary rounded-full">
          {count}
        </span>
      )}
    </TabsTrigger>
  );
};

export const AnalyticsTabContent = ({ value, children }: { value: string; children: ReactNode }) => {
  return (
    <TabsContent value={value} className="space-y-6 mt-6">
      {children}
    </TabsContent>
  );
};
